export class Microsoft365UserRestoreWorkload {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "Microsoft365UserRestoreWorkloadType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365UserRestoreWorkload.attributeTypeMap;
    }
    constructor() {
    }
}
